var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAustralia = function SvgAustralia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Australia_svg__a",
    width: 182,
    height: 182,
    x: 9,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 9.09H9.091v181.82h181.818V9.091Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Australia_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E307C",
    d: "M190.425 109.278c5.126-49.945-31.207-94.59-81.152-99.716C59.327 4.436 14.683 40.77 9.557 90.715c-5.126 49.945 31.207 94.59 81.152 99.715 49.946 5.126 94.59-31.206 99.716-81.152"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "evenodd",
    d: "m56.905 103.604 2.796 8.622 8.44-3.203-4.975 7.528 7.746 4.611-8.988.782 1.242 8.943-6.261-6.547-6.2 6.547 1.242-8.943-9.023-.782 7.78-4.611-5-7.528 8.457 3.203zm95.659 15.491 1.354 4.108 4.012-1.52-2.37 3.578 3.699 2.205-4.307.365.608 4.255-2.996-3.117-2.935 3.117.59-4.255-4.29-.365 3.7-2.205-2.371-3.578 4.021 1.52zm-23.891-37.86 1.32 4.098 4.012-1.537-2.371 3.604 3.691 2.197-4.281.356.59 4.272-2.961-3.117-2.97 3.117.591-4.272-4.29-.356 3.699-2.197-2.37-3.604 4.02 1.537 1.32-4.098m23.891-25.912 1.354 4.098 4.012-1.51-2.37 3.568 3.699 2.206-4.307.373.608 4.255-2.996-3.117-2.935 3.118.59-4.255-4.29-.374 3.7-2.206-2.371-3.569 4.021 1.511 1.285-4.098m21.292 19.537 1.294 4.1 4.055-1.529-2.396 3.587 3.716 2.188-4.307.382.608 4.264-2.97-3.127-2.97 3.127.599-4.264-4.298-.382 3.699-2.188-2.361-3.587 4.02 1.529 1.311-4.1m-11.707 19.183 1.051 2.553 2.735.209-2.084 1.77.643 2.684-2.345-1.459-2.327 1.459.643-2.683-2.102-1.771 2.752-.209 1.034-2.553M58.92 18.886v10.021H43.34a91.48 91.48 0 0 0-18.495 19.929H58.91v19.929h19.903V48.836h49.852V28.907H78.814V11.575a89.986 89.986 0 0 0-19.895 7.311",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "evenodd",
    d: "m40.43 31.33 74.87 37.435h13.347v-6.687L51.154 23.323A91.301 91.301 0 0 0 40.43 31.33",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "evenodd",
    d: "M113.145 10.037 20.118 56.564a90.343 90.343 0 0 0-5.523 12.2h7.867l106.175-53.1v-1.962a89.84 89.84 0 0 0-15.492-3.665",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E42229",
    fillRule: "evenodd",
    d: "M62.886 16.993v15.891H38.684a91.663 91.663 0 0 0-10.95 11.966h35.152v23.915h11.957V44.85h53.804V32.884H74.843V12.625a89.665 89.665 0 0 0-11.957 4.368",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E42229",
    fillRule: "evenodd",
    d: "m116.497 10.593-36.61 18.323h8.918l33.892-16.968a91.479 91.479 0 0 0-6.2-1.355m-73.16 18.314a82.335 82.335 0 0 1 2.197-1.702l3.413 1.702h-5.61m45.469 19.929 39.866 19.929V64.31L97.715 48.844l-8.91-.008M14.594 68.765a90.17 90.17 0 0 1 1.337-3.421l33.007-16.5h8.91l-39.85 19.93h-3.413l.009-.01Z",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E8E",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0,
    strokeWidth: 3,
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909Z"
  })));
};
export default SvgAustralia;